import './Mobile.scss';
import { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Application, Assets, AnimatedSprite } from 'pixi.js';
import { ScratchCard } from 'scratchcard-js';

import bull from "./assets/bull.png";
import chicken from "./assets/chicken.png";
import doggy from "./assets/doggy.png";
import dragon from "./assets/dragon.png";
import horse from "./assets/horse.png";
import lamb from "./assets/lamb.png";
import mice from "./assets/mice.png";
import monkey from "./assets/monkey.png";
import piggy from "./assets/piggy.png";
import rabbit from "./assets/rabbit.png";
import snake from "./assets/snake.png";
import tiger from "./assets/tiger.png";

import redCircle from "./assets/redcircle.png";
import redLantern from "./assets/redlantern.png";
import videoframe from "./assets/videoframe.png";
import upperBg from "./assets/upperbg.png";
import logoSpin from "./assets/logo_spin.png";
import logo from "./assets/logo.png";
import scratch from "./assets/scratch.png";
import redpack1 from "./assets/redpacket1.png";
import redpack2 from "./assets/redpacket2.png";

import popupvideoframe from "./assets/frame-horizon.png";
import verticalvideoframe from "./assets/frame-vertical.png";
import close from "./assets/close-button.png";

import bull_word from "./assets/words/ox.png";
import chicken_word from "./assets/words/chicken.png";
import doggy_word from "./assets/words/dog.png";
import dragon_word from "./assets/words/dragon.png";
import horse_word from "./assets/words/horse.png";
import lamp_word from "./assets/words/goat.png";
import mice_word from "./assets/words/rat.png";
import monkey_word from "./assets/words/monkey.png";
import piggy_word from "./assets/words/pig.png";
import rabbit_word from "./assets/words/rabbit.png";
import snake_word from "./assets/words/snake.png";
import tiger_word from "./assets/words/tiger.png";

import career_button from "./assets/career_button.png";
import health_button from "./assets/health_button.png";
import wealth_button from "./assets/wealth_button.png";

import * as PIXI from 'pixi.js';

function Mobile() {
  const navigate = useNavigate();
  const didInit = useRef(false);

  const [bigg, setBigg] = useState(0);
  const [reelShow, setReelShow] = useState(false);

  const [hideBackShadow, setHideBackShadow] = useState(true);
  const [hideZodiacVideo, setHideZodiacVideo] = useState(true);

  const [zodiacIcon, setZodiacIcon] = useState(snake);
  const [zodiacWord, setZodiacWord] = useState(snake_word);

  const [hideCareer, setHideCareer] = useState(true);
  const [careerBtn, setCareerBtn] = useState(career_button);

  // overlayActive = true when any modal is open
  const overlayActive = !hideBackShadow;

  // lock body scroll only when overlay is open
  useEffect(() => {
    document.body.style.overflow = hideBackShadow ? "auto" : "hidden";
  }, [hideBackShadow]);

  useEffect(() => {
    if (didInit.current) return;
    didInit.current = true;

    if (window.innerWidth / window.innerHeight >= 1) {
      navigate("/desktop");
      return;
    }

    let app = null;
    const timers = [];
    let cancelled = false;
    let reelScrollHandler = null;

    // IMPORTANT: refs used across init() and createHeavySprites()
    let bottom_loopRef = null; // Lower Background_R
    let bottom_elemRef = null; // Bottom elem animation

    // avoid loading heavy pack multiple times
    let heavyLoading = false;
    let heavyLoaded = false;

    // ============= Packs ============
    const TOP_PACK = [
      '/horsetitle-1.json',
      '/click_start-0.json',
      '/click_loop-0.json',
      '/bestWealth.json',
      '/bestHealth.json',
      '/bestCareer-0.json',
      '/bottom-0.json',
      '/reel-0.json',
      '/reel_light-0.json',
    ];

    const HEAVY_PACK = [
      '/bottom-elem-0.json',
      '/bottom-elem-1.json',
      '/bottom-elem-2.json',
      '/bottom-elem-3.json',
      '/bottom-elem-4.json',
      '/bottom-elem-5.json',
      '/bottom-elem-6.json',
      '/bottom-elem-7.json',
      '/wishes-0.json',
      '/fortuneCat-0.json',
      '/backtohuat_loop-0.json',
      '/backword_loop-0.json',
    ];

    // ============= Layer helper ============
    const applyBottomLayering = (wishSprite) => {
      if (!app) return;
      app.stage.sortableChildren = true;

      // base
      if (bottom_loopRef) bottom_loopRef.zIndex = 0;

      // wishes in the middle
      if (wishSprite) wishSprite.zIndex = 5;

      // bottom elem on top
      if (bottom_elemRef) bottom_elemRef.zIndex = 10;

      app.stage.sortChildren();
    };

    // ============= Heavy sprite creation (runs only after HEAVY_PACK loaded) ============
    const createHeavySprites = () => {
      if (!app || cancelled) return;

      // -------- Fortune Cat (animated) --------
      const fortuneSheet = PIXI.Assets.get('/fortuneCat-0.json');
      if (fortuneSheet?.textures) {
        const frames = Object.keys(fortuneSheet.textures).sort((a, b) => {
          const na = parseInt(a.match(/\d+/)?.[0] ?? 0, 10);
          const nb = parseInt(b.match(/\d+/)?.[0] ?? 0, 10);
          return na - nb;
        });

        const fortuneCat = new PIXI.AnimatedSprite(frames.map(f => fortuneSheet.textures[f]));
        fortuneCat.anchor.set(0.5);
        fortuneCat.animationSpeed = 0.1;
        fortuneCat.loop = true;

        const targetW = window.innerWidth * 0.78;
        fortuneCat.scale.set(targetW / fortuneCat.width);
        fortuneCat.position.set(window.innerWidth * 0.5, window.innerWidth * 1.52);

        fortuneCat.play();
        app.stage.addChild(fortuneCat);
      }

      // -------- Back-to-Huat visuals --------
      const backtohuat_loop_anim = Assets.cache.get('/backtohuat_loop-0.json')?.data?.animations;
      if (backtohuat_loop_anim) {
        const backtohuat_loop = AnimatedSprite.fromFrames(backtohuat_loop_anim["Back-to-Huat_Holder"]);
        backtohuat_loop.animationSpeed = 0.5;
        backtohuat_loop.setSize(window.innerWidth * 0.79, window.innerWidth * 0.145);
        backtohuat_loop.position.set(window.innerWidth * 0.1, window.innerWidth * 2.15);
        backtohuat_loop.loop = true;

        timers.push(setTimeout(() => backtohuat_loop.play(), 2000));
        backtohuat_loop.onLoop = () => {
          backtohuat_loop.stop();
          timers.push(setTimeout(() => backtohuat_loop.play(), 2000));
        };

        app.stage.addChild(backtohuat_loop);
      }

      const backword_loop_anim = Assets.cache.get('/backword_loop-0.json')?.data?.animations;
      if (backword_loop_anim) {
        const backword_loop = AnimatedSprite.fromFrames(backword_loop_anim["Back-to-Huat_Wordings"]);
        backword_loop.animationSpeed = 0.5;
        backword_loop.setSize(window.innerWidth * 0.75, window.innerWidth * 0.138);
        backword_loop.position.set(window.innerWidth * 0.122, window.innerWidth * 2.155);
        backword_loop.loop = true;
        backword_loop.play();

        backword_loop.onLoop = () => {
          backword_loop.stop();
          timers.push(setTimeout(() => backword_loop.play(), 5000));
        };

        app.stage.addChild(backword_loop);
      }

      // -------- Bottom elem (multi-atlas) --------
      const allFrames = [];
      for (let i = 0; i <= 7; i++) {
        const sheet = PIXI.Assets.get(`/bottom-elem-${i}.json`);
        if (!sheet?.textures) continue;

        Object.keys(sheet.textures).forEach(frameName => {
          allFrames.push({ name: frameName, texture: sheet.textures[frameName] });
        });
      }

      allFrames.sort((a, b) => {
        const na = parseInt(a.name.match(/\d+/)?.[0] ?? 0, 10);
        const nb = parseInt(b.name.match(/\d+/)?.[0] ?? 0, 10);
        return na - nb;
      });

      if (allFrames.length) {
        const bottom_elem = new PIXI.AnimatedSprite(allFrames.map(f => f.texture));
        bottom_elemRef = bottom_elem;

        bottom_elem.animationSpeed = 0.5;
        bottom_elem.loop = true;
        bottom_elem.setSize(window.innerWidth, window.innerWidth * 0.595);
        bottom_elem.position.set(0, window.innerWidth * 2.4);
        bottom_elem.play();
        app.stage.addChild(bottom_elem);
      }

      // -------- Wishes (start then loop) --------
      app.stage.children
        .filter((c) => c?.name === 'CNY_WISHES_START' || c?.name === 'CNY_WISHES_LOOP')
        .forEach((c) => {
          app.stage.removeChild(c);
          if (typeof c.destroy === 'function') c.destroy({ children: true });
        });

      const wishStartFrames = [];
      const wishLoopFrames = [];

      for (let i = 0; i <= 119; i++) {
        const frame = `CNY WISHES(R1)${String(i).padStart(3, '0')}.png`;
        if (i < 50) wishStartFrames.push(frame);
        else wishLoopFrames.push(frame);
      }

      const FRAME_X = window.innerWidth * 0.5;
      const FRAME_Y = window.innerWidth * 2.33;

      const wish_start = new PIXI.AnimatedSprite(wishStartFrames.map(f => PIXI.Texture.from(f)));
      wish_start.name = 'CNY_WISHES_START';
      wish_start.anchor.set(0.5);
      wish_start.animationSpeed = 0.5;
      wish_start.loop = false;
      wish_start.eventMode = 'none';

      wish_start.setSize(window.innerWidth * 1.15, window.innerWidth * 0.99);
      wish_start.position.set(FRAME_X, FRAME_Y);

      wish_start.play();
      app.stage.addChild(wish_start);

      // ✅ wishes behind bottom_elem
      applyBottomLayering(wish_start);

      wish_start.onComplete = () => {
        app.stage.removeChild(wish_start);
        wish_start.destroy();

        const wish_loop = new PIXI.AnimatedSprite(wishLoopFrames.map(f => PIXI.Texture.from(f)));
        wish_loop.name = 'CNY_WISHES_LOOP';
        wish_loop.anchor.set(0.5);
        wish_loop.animationSpeed = 0.5;
        wish_loop.loop = true;
        wish_loop.eventMode = 'none';

        wish_loop.setSize(window.innerWidth * 1.15, window.innerWidth * 0.99);
        wish_loop.position.set(FRAME_X, FRAME_Y);

        wish_loop.play();
        app.stage.addChild(wish_loop);

        // ✅ wishes behind bottom_elem (loop too)
        applyBottomLayering(wish_loop);
      };
    };

    // ============= Heavy loader ============
    const loadHeavy = async () => {
      if (heavyLoaded || heavyLoading || cancelled) return;
      heavyLoading = true;

      try {
        await Assets.load(HEAVY_PACK);
        heavyLoaded = true;
        createHeavySprites();
      } finally {
        heavyLoading = false;
      }
    };

    const init = async () => {
      app = new Application();

      // iPhone safe DPR cap
      const dpr = Math.min(window.devicePixelRatio || 1, 1);

      await app.init({
        backgroundAlpha: 0,
        width: window.innerWidth,
        height: window.innerHeight * 2,
        resolution: dpr,
        autoDensity: true
      });

      // Append canvas
      document.getElementById("canvas1")?.appendChild(app.canvas);

      // ✅ VISUAL ONLY
      app.canvas.style.pointerEvents = 'none';
      app.canvas.style.touchAction = 'pan-y';

      // ✅ TOP pack first
      await Assets.load(TOP_PACK);
      document.body.style.display = "block";

      // =========================
      // 1) HORSE TITLE + CLICK CTA
      // =========================
      timers.push(setTimeout(() => {
        if (cancelled) return;

        const titleFrames = [];
        for (let i = 0; i <= 48; i++) {
          titleFrames.push(`TITLE${String(i).padStart(3, "0")}.png`);
        }

        const words = new PIXI.AnimatedSprite(titleFrames.map(f => PIXI.Texture.from(f)));
        words.anchor.set(0.5);
        words.animationSpeed = 0.5;
        words.loop = false;

        words.setSize(window.innerWidth * 0.80, window.innerWidth * 0.37);
        words.position.set(window.innerWidth * 0.5, window.innerWidth * 0.52);
        app.stage.addChild(words);

        const click_start_anim = Assets.cache.get('/click_start-0.json')?.data?.animations;
        if (click_start_anim) {
          const click_start = AnimatedSprite.fromFrames(click_start_anim["Click to Watch"]);
          click_start.setSize(window.innerWidth * 0.5, window.innerWidth * 0.107);
          click_start.animationSpeed = 0.5;
          click_start.position.set(window.innerWidth * 0.25, window.innerWidth * 0.64);
          click_start.loop = false;
          app.stage.addChild(click_start);

          click_start.onComplete = () => {
            app.stage.removeChild(click_start);

            const click_loop_anim = Assets.cache.get('/click_loop-0.json')?.data?.animations;
            if (!click_loop_anim) return;

            const click_loop = AnimatedSprite.fromFrames(click_loop_anim["Click to Watch"]);
            click_loop.animationSpeed = 0.5;
            click_loop.setSize(window.innerWidth * 0.5, window.innerWidth * 0.107);
            click_loop.position.set(window.innerWidth * 0.25, window.innerWidth * 0.64);
            click_loop.loop = true;

            click_loop.play();
            click_loop.onLoop = () => {
              click_loop.stop();
              timers.push(setTimeout(() => click_loop.play(), 2000));
            };

            app.stage.addChild(click_loop);
          };

          click_start.play();
        }

        words.play();
      }, 300));

      // =========================
      // 2) TOP 3 BEST buttons (visual only)
      // =========================
      timers.push(setTimeout(() => {
        if (cancelled) return;

        const buildBestButton = (prefix, x, y) => {
          const startFrames = [];
          const loopFrames = [];

          for (let i = 0; i <= 119; i++) {
            const frame = `${prefix}${String(i).padStart(3, "0")}.png`;
            if (i <= 58) startFrames.push(frame);
            else loopFrames.push(frame);
          }

          const start = new PIXI.AnimatedSprite(startFrames.map(f => PIXI.Texture.from(f)));
          start.animationSpeed = 0.5;
          start.loop = false;
          start.setSize(window.innerWidth * 0.337, window.innerWidth * 0.2);
          start.position.set(x, y);
          start.play();
          app.stage.addChild(start);

          start.onComplete = () => {
            app.stage.removeChild(start);
            start.destroy();

            const loop = new PIXI.AnimatedSprite(loopFrames.map(f => PIXI.Texture.from(f)));
            loop.animationSpeed = 0.5;
            loop.loop = true;
            loop.setSize(window.innerWidth * 0.337, window.innerWidth * 0.2);
            loop.position.set(x, y);
            loop.play();
            app.stage.addChild(loop);
          };
        };

        buildBestButton("BEST_WEALTH", window.innerWidth * 0.05, window.innerWidth * 0.01);
        buildBestButton("BEST_HEALTH", window.innerWidth * 0.372, window.innerWidth * 0.01);
        buildBestButton("BEST_CAREER", window.innerWidth * 0.69, window.innerWidth * 0.01);
      }, 450));

      // =========================
      // 3) Bottom background loop (visual)
      // =========================
      const bottom_loop_anim = Assets.cache.get('/bottom-0.json')?.data?.animations;
      if (bottom_loop_anim) {
        const bottom_loop = AnimatedSprite.fromFrames(bottom_loop_anim["Lower Background_R"]);
        bottom_loopRef = bottom_loop;

        bottom_loop.animationSpeed = 0.5;
        bottom_loop.setSize(window.innerWidth, window.innerWidth * 1.5116);
        bottom_loop.position.set(0, window.innerWidth * 1.505);
        bottom_loop.loop = true;
        bottom_loop.play();
        app.stage.addChild(bottom_loop);

        // base zIndex
        app.stage.sortableChildren = true;
        bottom_loop.zIndex = 0;
        app.stage.sortChildren();
      }

      // =========================
      // 4) Reel animation (visual)
      // =========================
      const reel_anim = Assets.cache.get('/reel-0.json')?.data?.animations;
      let reel = null;
      if (reel_anim) {
        reel = AnimatedSprite.fromFrames(reel_anim["Scroll Animation"]);
        reel.animationSpeed = 0.5;
        reel.setSize(window.innerWidth * 0.952, window.innerWidth * 0.358);
        reel.position.set(window.innerWidth * 0.025, window.innerWidth * 1.8);
        reel.loop = false;
        app.stage.addChild(reel);

        reel.onComplete = () => {
          const reel_light_anim = Assets.cache.get('/reel_light-0.json')?.data?.animations;
          if (!reel_light_anim) return;

          const reel_light = AnimatedSprite.fromFrames(reel_light_anim["Scroll Light Flare"]);
          reel_light.animationSpeed = 0.5;
          reel_light.setSize(window.innerWidth * 0.952, window.innerWidth * 0.358);
          reel_light.position.set(window.innerWidth * 0.025, window.innerWidth * 1.8);
          reel_light.loop = false;
          reel_light.play();
          app.stage.addChild(reel_light);
        };
      }

      // show reel based on scroll + trigger heavy load
      if (window.innerHeight / window.innerWidth < 1.8) {
        let once = false;
        reelScrollHandler = () => {
          if (!once && window.scrollY >= 100) {
            once = true;
            setReelShow(true);
            if (reel) reel.play();
            loadHeavy();
          }
        };
        document.addEventListener('scroll', reelScrollHandler, { passive: true });
      } else {
        setReelShow(true);
        if (reel) reel.play();
      }

      // fallback: load heavy after 1s
      timers.push(setTimeout(() => {
        if (!cancelled) loadHeavy();
      }, 1000));

      // random big zodiac highlight
      const randomBig = () => {
        if (cancelled) return;
        timers.push(setTimeout(() => {
          if (cancelled) return;
          const next = Math.floor(Math.random() * 12) + 1;
          setBigg(next);
          timers.push(setTimeout(() => setBigg(0), 250));
          randomBig();
        }, Math.floor(Math.random() * (3000 - 250 + 1) + 250)));
      };

      // scratch init after DOM exists
      const initScratch = () => {
        const randNum = Math.floor(Math.random() * 10000);
        const pad = (num, size) => {
          let s = String(num);
          while (s.length < size) s = "0" + s;
          return s;
        };

        const sc = new ScratchCard('#scratch-numbers', {
          scratchType: 3,
          containerWidth: document.getElementById("scratch-img")?.offsetWidth || 0,
          containerHeight: document.getElementById("scratch-img")?.offsetHeight || 0,
          imageForwardSrc: '/scratch.png',
          imageBackgroundSrc: '',
          htmlBackground: '<div class="numbers">' + pad(randNum, 4) + '</div>',
          clearZoneRadius: 10,
          nPoints: 30,
          pointSize: 4,
          percentToFinish: 70,
          callback: function () {},
          brushSrc: "",
          enabledPercentUpdate: true
        });

        sc.init();
      };

      timers.push(setTimeout(() => {
        if (!cancelled) {
          initScratch();
          randomBig();
        }
      }, 50));
    };

    init();

    return () => {
      cancelled = true;
      timers.forEach(clearTimeout);
      if (reelScrollHandler) document.removeEventListener('scroll', reelScrollHandler);

      try { app?.destroy(true); } catch {}
      const c1 = document.getElementById("canvas1");
      if (c1) c1.innerHTML = "";
    };
  }, [navigate]);

  // ======= DOM click handlers =======
  const showZodiacVideo = (zodiac) => {
    switch (zodiac) {
      case "bull": setZodiacIcon(bull); setZodiacWord(bull_word); break;
      case "chicken": setZodiacIcon(chicken); setZodiacWord(chicken_word); break;
      case "doggy": setZodiacIcon(doggy); setZodiacWord(doggy_word); break;
      case "dragon": setZodiacIcon(dragon); setZodiacWord(dragon_word); break;
      case "horse": setZodiacIcon(horse); setZodiacWord(horse_word); break;
      case "lamb": setZodiacIcon(lamb); setZodiacWord(lamp_word); break;
      case "mice": setZodiacIcon(mice); setZodiacWord(mice_word); break;
      case "monkey": setZodiacIcon(monkey); setZodiacWord(monkey_word); break;
      case "piggy": setZodiacIcon(piggy); setZodiacWord(piggy_word); break;
      case "rabbit": setZodiacIcon(rabbit); setZodiacWord(rabbit_word); break;
      case "snake": setZodiacIcon(snake); setZodiacWord(snake_word); break;
      case "tiger": setZodiacIcon(tiger); setZodiacWord(tiger_word); break;
      default: break;
    }

    const video = document.getElementById("zodiac-v");
    if (!video) return;

    video.pause();
    video.removeAttribute('src');
    video.load();

    video.src = `${zodiac}.mp4`;
    video.load();

    setHideBackShadow(false);
    setHideZodiacVideo(false);
    video.play().catch(() => {});
  };

  const closeZodiacVideo = () => {
    setHideBackShadow(true);
    setHideZodiacVideo(true);

    const video = document.getElementById("zodiac-v");
    if (!video) return;

    try { video.pause(); } catch {}
    video.removeAttribute("src");
    video.load();
  };

  const showHealth = () => {
    setCareerBtn(health_button);
    const video = document.getElementById("career-v");
    if (!video) return;

    video.pause();
    video.removeAttribute('src');
    video.load();

    video.src = `health.mp4`;
    video.load();

    setHideBackShadow(false);
    setHideCareer(false);
    video.play().catch(() => {});
  };

  const showWealth = () => {
    setCareerBtn(wealth_button);
    const video = document.getElementById("career-v");
    if (!video) return;

    video.pause();
    video.removeAttribute('src');
    video.load();

    video.src = `wealth.mp4`;
    video.load();

    setHideBackShadow(false);
    setHideCareer(false);
    video.play().catch(() => {});
  };

  const showCareer = () => {
    setCareerBtn(career_button);
    const video = document.getElementById("career-v");
    if (!video) return;

    video.pause();
    video.removeAttribute('src');
    video.load();

    video.src = `career.mp4`;
    video.load();

    setHideBackShadow(false);
    setHideCareer(false);
    video.play().catch(() => {});
  };

  const closeCareer = () => {
    setHideBackShadow(true);
    setHideCareer(true);

    const video = document.getElementById("career-v");
    if (!video) return;

    try { video.pause(); } catch {}
    video.removeAttribute('src');
    video.load();
  };

  // Position zodiac icons around circle
  useEffect(() => {
    const items = document.querySelectorAll(".zodiac-container");
    const angle = 360 / 12;
    const radian = angle * Math.PI / 180;

    items.forEach((zodiac, index) => {
      setTimeout(() => {
        zodiac.style.left = (Math.sin(-radian * index) * 73 + 50).toFixed(0) + "%";
        zodiac.style.top = (Math.cos(-radian * index) * 73 + 50).toFixed(0) + "%";
        zodiac.style.opacity = 1;
      }, index * 75);
    });
  }, []);

  return (
    <div className="mobile">
      <div className={'back-shadow ' + (hideBackShadow ? 'hide' : '')}></div>

      <div className={'zodiac-video ' + (hideZodiacVideo ? 'hide' : '')}>
        <img className='close' src={close} alt="" loading="eager" onClick={closeZodiacVideo} />
        <div className='word-container'>
          <img src={zodiacIcon} className="icon" alt="" loading="eager" />
          <img src={zodiacWord} className="word" alt="" loading="eager" />
        </div>
        <img className='videoframe' src={popupvideoframe} alt="" loading="eager" />
        <video id="zodiac-v" controls playsInline preload="none" />
      </div>

      <div className={'career-video ' + (hideCareer ? 'hide' : '')}>
        <img className='top-button' src={careerBtn} alt="" loading="eager" />
        <img className='close' src={close} alt="" loading="eager" onClick={closeCareer} />
        <img className='videoframe' src={verticalvideoframe} alt="" loading="eager" />
        <video id="career-v" controls playsInline preload="none" />
      </div>

      <img src={upperBg} className="upper-bg" alt="" loading="eager" />

      <div className='button-group' style={{ pointerEvents: overlayActive ? 'none' : 'auto' }}>
        <div id="button1" onClick={showWealth} className='button1'></div>
        <div id="button2" onClick={showHealth} className='button2'></div>
        <div id="button3" onClick={showCareer} className='button3'></div>
      </div>

      <img src={redCircle} className="red-circle" alt="" loading="eager" />

      <div id="canvas1"></div>

      <div className="wheel" style={{ pointerEvents: overlayActive ? 'none' : 'auto' }}>
        <div className="logo-container">
          <img src={logo} className="logo" alt="" loading="eager" />
          <img src={logoSpin} className="logo-spin" alt="" loading="eager" />
        </div>
        <div className="zodiacs">
          <div className="zodiac-container"><img src={bull} className={(bigg === 1 ? "showBig" : "") + " zodiac bull"} alt="" loading="eager" onClick={() => showZodiacVideo("bull")} /></div>
          <div className="zodiac-container"><img src={chicken} className={(bigg === 2 ? "showBig" : "") + " zodiac chicken"} alt="" loading="eager" onClick={() => showZodiacVideo("chicken")} /></div>
          <div className="zodiac-container"><img src={doggy} className={(bigg === 3 ? "showBig" : "") + " zodiac doggy"} alt="" loading="eager" onClick={() => showZodiacVideo("doggy")} /></div>
          <div className="zodiac-container"><img src={dragon} className={(bigg === 4 ? "showBig" : "") + " zodiac dragon"} alt="" loading="eager" onClick={() => showZodiacVideo("dragon")} /></div>
          <div className="zodiac-container"><img src={horse} className={(bigg === 5 ? "showBig" : "") + " zodiac horse"} alt="" loading="eager" onClick={() => showZodiacVideo("horse")} /></div>
          <div className="zodiac-container"><img src={lamb} className={(bigg === 6 ? "showBig" : "") + " zodiac lamb"} alt="" loading="eager" onClick={() => showZodiacVideo("lamb")} /></div>
          <div className="zodiac-container"><img src={mice} className={(bigg === 7 ? "showBig" : "") + " zodiac mice"} alt="" loading="eager" onClick={() => showZodiacVideo("mice")} /></div>
          <div className="zodiac-container"><img src={monkey} className={(bigg === 8 ? "showBig" : "") + " zodiac monkey"} alt="" loading="eager" onClick={() => showZodiacVideo("monkey")} /></div>
          <div className="zodiac-container"><img src={piggy} className={(bigg === 9 ? "showBig" : "") + " zodiac piggy"} alt="" loading="eager" onClick={() => showZodiacVideo("piggy")} /></div>
          <div className="zodiac-container"><img src={rabbit} className={(bigg === 10 ? "showBig" : "") + " zodiac rabbit"} alt="" loading="eager" onClick={() => showZodiacVideo("rabbit")} /></div>
          <div className="zodiac-container"><img src={snake} className={(bigg === 11 ? "showBig" : "") + " zodiac snake"} alt="" loading="eager" onClick={() => showZodiacVideo("snake")} /></div>
          <div className="zodiac-container"><img src={tiger} className={(bigg === 12 ? "showBig" : "") + " zodiac tiger"} alt="" loading="eager" onClick={() => showZodiacVideo("tiger")} /></div>
        </div>
      </div>

      <div className="video-box">
        <img src={videoframe} className="frame" alt="" />
      </div>

      <div className="redlantern">
        <img src={redLantern} alt="" loading="eager" />
      </div>

      <a
        href="https://www.hiso33sg4.com/en-sg/mini-game"
        target="_blank"
        rel="noreferrer"
        aria-label="fortune link"
        style={{
          position: 'absolute',
          left: '50%',
          transform: 'translateX(-50%)',
          top: '145vw',
          width: '52vw',
          height: '30vw',
          zIndex: 999999,
          pointerEvents: overlayActive ? 'none' : 'auto',
          background: 'none'
        }}
      />

      <div className="redpack-group">
        <img src={redpack1} className="redpack redpack1" alt="" loading="eager" />
        <img src={redpack2} className="redpack redpack2" alt="" loading="eager" />
      </div>

      <div className={(reelShow ? "showing" : "") + " reel-word"}>
        <span>SCRATCH & GET <br /> <i className="small-text">4 Lucky Numbers</i></span>
        <div id="scratch-container">
          <img src={scratch} id="scratch-img" alt="" loading="eager" />
          <div id="scratch-numbers"></div>
        </div>
      </div>

      <div
        className='backtobutton'
        onClick={() => { window.location.href = "https://www.hiso33play.com"; }}
        style={{ pointerEvents: overlayActive ? 'none' : 'auto' }}
      ></div>
    </div>
  );
}

export default Mobile;
